// export const BASE_URL = "http://localhost:8000/"
export const BASE_URL = "https://techazora-backend.vercel.app/"
export const loginapi = `${BASE_URL}api/admin/login`
export const GET_BLOG_API = `${BASE_URL}api/blog/all`
export const GET_SINGLE_BLOG_API = `${BASE_URL}api/blog`
export const CREATE_BLOG_API = `${BASE_URL}api/blog/create`
export const UPDATE_BLOG_API = `${BASE_URL}api/blog/update`
// project
export const get_project_API = `${BASE_URL}api/project/all`
export const get_single_project_API = `${BASE_URL}api/project`
export const create_project_API = `${BASE_URL}api/project/create`
export const update_project_API = `${BASE_URL}api/project/update`
export const delete_project_Api = `${BASE_URL}api/project`

// verify-ducument
export const get_VerifyDocs_API = `${BASE_URL}api/ducument/all`
export const get_single_VerifyDocs_API = `${BASE_URL}api/ducument`
export const create_VerifyDocs_API = `${BASE_URL}api/ducument/create`
export const update_VerifyDocs_API = `${BASE_URL}api/ducument/update`
export const delete_VerifyDocs_Api = `${BASE_URL}api/ducument`
export const verifyducumentByIdAPi = `${BASE_URL}api/ducument/verify-document`
// conact
export const get_contact_API = `${BASE_URL}api/contact/All`
export const create_contact_API = `${BASE_URL}api/contact/create`
export const update_contact_API = `${BASE_URL}api/contact/update`
export const delete_contact_Api = `${BASE_URL}api/contact`